import * as THREE from 'three';
import { VRMLLoader } from 'three/examples/jsm/loaders/VRMLLoader';
import { FikoEksen } from './FikoEksen';
import { FikoObje3D } from './FikoObje3D';
import { FikoSahne } from './FikoSahne';
import { FikoAPTCAT } from './FikoThreeCam/FikoAPTCAD';
import { FikoCizimWRL } from './FikoThreeCam/FikoCizimWRL';
import { FikoTakim } from './FikoThreeCam/FikoTakim';
import { FikoTakimFrezeleme } from './FikoThreeCam/FikoTakimFrezeleme';
import { FikoTakimYolu } from './FikoThreeCam/FikoTakimYolu';
import { FikoVektorTakimYol3D } from './FikoThreeCam/FikoVektorTakimYol3d';
import { FikoVektor3D } from './FikoVektor3d';

export class FikoImporterAPTCAT {

    aktiviteler?: { ismi: string, alt: any[], koordinatlar?: FikoVektorTakimYol3D[], takim?: FikoTakim, takimYonu?: number[], toplamSure?: number }[]

    eksen: FikoEksen;

    takimYolu: FikoTakimYolu = new FikoTakimYolu();

    arrayApt: string[];
    tarihi: Date;
    programIsmi: string;
    kureMerkezi: boolean;
    operasyonIsmi: string;
    eksenKoord: { x?: FikoVektor3D, y?: FikoVektor3D, z?: FikoVektor3D, o?: FikoVektor3D };

    constructor(public sahne?: FikoSahne) {

    }

    async alDosyadan(dosya: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let _this = this;
            const reader = new FileReader();
            reader.onload = async (e) => {
                const buffer = e.target?.result as ArrayBuffer;
                let text: string;
                try {
                    text = new TextDecoder('utf-8', { fatal: true }).decode(buffer);
                } catch {
                    text = new TextDecoder('windows-1254').decode(buffer);
                }
                _this.arrayApt = text.split("\n");
                await _this.parcala();
                resolve({
                    programIsmi: _this.programIsmi,
                    tarihi: _this.tarihi,
                    kureMerkezi: _this.kureMerkezi,
                    operasyonIsmi: _this.operasyonIsmi,
                    eksen: _this.eksen,
                    eksenKoord: _this.eksenKoord,
                    takimYolu: _this.takimYolu,
                    aktiviteler: _this.aktiviteler,
                });
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsArrayBuffer(dosya);
        });
    }

    isleArray(array: any) {
        // return new Promise((resolve, reject) => {

        let _this = this;
        // const loader: THREE.FileLoader = new THREE.FileLoader();

        // let fikoApt = new FikoAPTCAT(_this.sahne);
        // fikoApt.strApt = data;
        _this.arrayApt = array;
        _this.parcala();
        return ({
            programIsmi: _this.programIsmi,
            tarihi: _this.tarihi,
            kureMerkezi: _this.kureMerkezi,
            operasyonIsmi: _this.operasyonIsmi,
            eksen: _this.eksen,
            eksenKoord: _this.eksenKoord,
            takimYolu: _this.takimYolu,
            aktiviteler: _this.aktiviteler,
        });
        /** NOT: Loader Bitimi */
        // });
        /** NOT: Promise Bitimi */

    }


    async parcalaStr(aptStr: string[]) {
        this.arrayApt = aptStr
        return this.parcala();
    }

    toplamKoordinatSayisi = 0;
    async parcala() {
        this.toplamKoordinatSayisi = 0;
        let lokalArrayApt = Object.assign([], this.arrayApt);
        /** Tarih Alınıyor */
        for (let index = 0; index < 4; index++) {
            const element = lokalArrayApt[index];
            if (element.indexOf("Generated on ") > -1) {
                const tarihRegex: RegExp = new RegExp(/(Generated on.*)\w+/g);
                this.tarihi = new Date(tarihRegex.exec(element)[0].replace("Generated on ", ""))
            };
        }
        lokalArrayApt.splice(0, 4);
        /** Program İsmi */
        this.programIsmi = lokalArrayApt[0].replace("$$ ", "").trim();
        /** Küre Merkezi */
        let mfgStarts = lokalArrayApt.join("\[fikoAyrac]").split(lokalArrayApt[0]).filter((el) => { return el.length > 0 })[0].trim();
        this.kureMerkezi = mfgStarts.indexOf("TOOL CENTER OUTPUT") > -1;
        /** Part Operasyonu İsmi */
        this.operasyonIsmi = /\$\$  .*/.exec(mfgStarts)[0].replace("$$  ", "")
        lokalArrayApt.splice(0, 1);
        /** */
        lokalArrayApt.splice(0, mfgStarts.split("\[fikoAyrac]").length - 1);
        /** Eksen Konum Koordinatları */
        let parsedKoor0 = lokalArrayApt[0].match(/[-+]?\d*\.\d+|\d+/g).map(Number);
        let parsedKoor1 = lokalArrayApt[1].match(/[-+]?\d*\.\d+|\d+/g).map(Number);
        let parsedKoor2 = lokalArrayApt[2].match(/[-+]?\d*\.\d+|\d+/g).map(Number);
        this.eksenKoord = {
            x: new FikoVektor3D(parsedKoor0[0], parsedKoor1[0], parsedKoor2[0]),
            y: new FikoVektor3D(parsedKoor0[1], parsedKoor1[1], parsedKoor2[1]),
            z: new FikoVektor3D(parsedKoor0[2], parsedKoor1[2], parsedKoor2[2]),
            o: new FikoVektor3D(parsedKoor0[3], parsedKoor1[3], parsedKoor2[3])
        }
        lokalArrayApt.splice(0, 5);
        /** Operasyonlar İçin Ayarlama Yapılıyor */
        let count = 0
        for (let index = 0; index < lokalArrayApt.length; index++) {
            const element = lokalArrayApt[index];
            if (!element.startsWith("$$ OPERATION NAME : ")) {
                count += 1;
            } else break;
        }
        lokalArrayApt.splice(0, count);
        /** Operasyonlar Gruplandırılıyor  */
        // console.log(lokalArrayApt)
        let parcalamaAktivite: any[] = [];// lokalArrayApt.join().split(/(\$\$ OPERATION NAME.*)/);
        this.aktiviteler = [];

        let baslangic = 0;
        for (let i = 0; i < lokalArrayApt.length; i++) {
            let element;
            lokalArrayApt[i] = lokalArrayApt[i].replace(/\n/g, '');
            element = lokalArrayApt[i].replace(/\n/g, '')
            if (element.startsWith("$$ OPERATION NAME : ")) {
                parcalamaAktivite.push(lokalArrayApt.slice(baslangic, i));
                let akt = {
                    ismi: lokalArrayApt[baslangic].replace("$$ OPERATION NAME : ", "").trim(),
                    alt: lokalArrayApt.slice(baslangic, i)
                }
                this.aktiviteler.push(akt)
                baslangic = i;
            } else if (i == lokalArrayApt.length - 1) {
                parcalamaAktivite.push(lokalArrayApt.slice(baslangic, i));
                let akt = {
                    ismi: lokalArrayApt[baslangic].replace("$$ OPERATION NAME : ", "").trim(),
                    alt: lokalArrayApt.slice(baslangic, i)
                }
                this.aktiviteler.push(akt)
            }
        }
        this.aktiviteler.splice(0, 1);

        /** Maksimum FEDRAT degerini bul (rapid traverse tespiti icin) */
        let maksIlerleme = 0;
        for (let idx = 0; idx < this.aktiviteler.length; idx++) {
            for (let j = 0; j < this.aktiviteler[idx].alt.length; j++) {
                const satir: string = this.aktiviteler[idx].alt[j];
                if (satir.startsWith("FEDRAT")) {
                    const val = this.ilerlemeAyikla(satir);
                    if (val > maksIlerleme) maksIlerleme = val;
                }
            }
        }

        /** Renk sabitleri: isleme=yesil, yaklasma=sari, uzaklasma=mavi, bosta=kirmizi */
        const RENK_ISLEME = new THREE.Color("chartreuse");
        const RENK_YAKLASMA = new THREE.Color("yellow");
        const RENK_UZAKLASMA = new THREE.Color("blue");
        const RENK_BOSTA = new THREE.Color("red");

        /** Koordinatlar İçin Dolaşma Başlıyor */
        let sonDevir: number = null;
        let sonIlerleme: number = null;
        let sonTakimYonu = [0, 0, 1];
        let sonTakim: FikoTakim = null;
        let sonZ: number = null;
        for (let index = 0; index < this.aktiviteler.length; index++) {
            const element = this.aktiviteler[index];

            element.toplamSure = 0;
            if (!element.koordinatlar) element.koordinatlar = [];
            for (let i = 0; i < element.alt.length; i++) {
                const hrkt: string = element.alt[i];

                if (hrkt.startsWith("CUTTER/")) {
                    sonTakim = this.takimAyikla(element);
                } else if (hrkt.startsWith("TLAXIS/")) {
                    sonTakimYonu = this.takimYonuAyikla(hrkt);
                } else if (hrkt.startsWith("SPINDL")) {
                    sonDevir = this.devirAyikla(hrkt);
                } else if (hrkt.startsWith("FEDRAT")) {
                    sonIlerleme = this.ilerlemeAyikla(hrkt);
                } else if (hrkt.startsWith("GOTO")) {
                    const parsedKoor = hrkt.match(/[-+]?\d*\.\d+|\d+/g).map(Number);
                    const z = parsedKoor[2];

                    /** Hareket tipi tespiti: rapid=yaklasma/uzaklasma/bosta, diger=isleme */
                    let renk: THREE.Color;
                    if (maksIlerleme > 0 && sonIlerleme >= maksIlerleme * 0.95) {
                        // Rapid traverse - Z yonune gore siniflandir
                        if (sonZ !== null && z > sonZ + 0.5) {
                            renk = RENK_UZAKLASMA; // Z yukari = uzaklasma (mavi)
                        } else if (sonZ !== null && z < sonZ - 0.5) {
                            renk = RENK_YAKLASMA; // Z asagi = yaklasma (sari)
                        } else {
                            renk = RENK_BOSTA; // Z ayni = bosta gecis (kirmizi)
                        }
                    } else {
                        renk = RENK_ISLEME; // Isleme (yesil)
                    }
                    sonZ = z;

                    element.takim = sonTakim;

                    let _poz = new FikoVektorTakimYol3D(parsedKoor[0], parsedKoor[1], parsedKoor[2]);

                    let _takimYolu = _poz;
                    _takimYolu.hiz = sonIlerleme;
                    _takimYolu.devir = sonDevir;
                    _takimYolu.renk = renk;

                    _takimYolu.takim = sonTakim;

                    _takimYolu.takimYonu.set(sonTakimYonu[0], sonTakimYonu[1], sonTakimYonu[2]);

                    _takimYolu.ekBilgiler = element;
                    _takimYolu.ekBilgiler.programIsmi = this.programIsmi;
                    element.koordinatlar.push(_takimYolu);
                    this.toplamKoordinatSayisi += 0
                }
            }
            element.takimYonu = sonTakimYonu;
            // element.alt = undefined;
        }

        // this.strApt = undefined;

        // this.name = this.programIsmi;


        await this.takimYoluEkle();

        lokalArrayApt = undefined;

        return true;
    }


    devirAyikla(aptLine: string): number {
        return aptLine.match(/[-+]?\d*\.\d+|\d+/g)?.map(Number)[0];
    }

    ilerlemeAyikla(aptLine: string): number {
        return aptLine.match(/[-+]?\d*\.\d+|\d+/g)?.map(Number)[0];
    }

    takimAyikla(toolChangeAktivite: any) {

        for (let s = 0; s < toolChangeAktivite.alt.length; s++) {
            const satir = toolChangeAktivite.alt[s];
            if (satir.startsWith("CUTTER/")) {
                const line = String(toolChangeAktivite.alt[s] + toolChangeAktivite.alt[s + 1]).replace("$", "").replace("CUTTER/", "");
                toolChangeAktivite.takimOlculer = { olculer: line.match(/[-+]?\d*\.\d+|\d+/g)?.map(Number) };
            }

        }

        return new FikoTakimFrezeleme(this.sahne, toolChangeAktivite.takimOlculer.olculer[0], toolChangeAktivite.takimOlculer.olculer[1], 200, toolChangeAktivite.takimOlculer.olculer[toolChangeAktivite.takimOlculer.olculer.length - 1]);
    }

    takimYonuAyikla(aptLine: string) {
        return aptLine.match(/[-+]?\d*\.\d+|\d+/g).map(Number);
    }

    async takimYoluEkle() {
        let _toplamSure: number = 0;
        /** NOT: O İşlemleri Burada Yap */
        this.takimYolu.name = this.programIsmi + ".FikoTakimYolu";

        this.takimYolu.noktalar = [];

        this.takimYolu.position.copy(this.eksenKoord.o);
        this.takimYolu.setRotationFromMatrix(new THREE.Matrix4().makeBasis(this.eksenKoord.x, this.eksenKoord.y, this.eksenKoord.z))

        // this.takimYolu.agactaGorunur = false;

        // this.ekle(this.takimYolu);

        // this.takimYolu.updateMatrix();
        // this.takimYolu.updateMatrixWorld(true);
        this.takimYolu.updateWorldMatrix(true, true);


        let birlesikNoktalar: FikoVektorTakimYol3D[] = new Array<FikoVektorTakimYol3D>(this.toplamKoordinatSayisi);
        let sonPoz = 0;
        for (let index = 0; index < this.aktiviteler.length; index++) {
            const element = this.aktiviteler[index];

            // birlesikNoktalar.length = birlesikNoktalar.length + element.koordinatlar.length;
            for (let ikoor = 0; ikoor < element.koordinatlar.length; ikoor++) {
                const koor = element.koordinatlar[ikoor];
                birlesikNoktalar[sonPoz] = koor;
                /** */
                const _localNokta = birlesikNoktalar[sonPoz];

                const ltw = this.takimYolu.localToWorld(_localNokta.clone())
                let wrldNokta = new FikoVektorTakimYol3D(ltw.x, ltw.y, ltw.z)
                let _localYon = _localNokta.takimYonu.clone().transformDirection(this.takimYolu.matrixWorld.clone());

                _localNokta.takimYonu = _localYon;

                _localNokta.copy(wrldNokta);

                if (sonPoz > 0) {
                    let  hesap = (birlesikNoktalar[sonPoz - 1].distanceTo(_localNokta) / (_localNokta.hiz / 60))
                    hesap = hesap != Infinity ? hesap : 0;
                    _toplamSure += hesap;
                    _localNokta.guncelSure = birlesikNoktalar[sonPoz - 1].guncelSure + hesap;

                    // _toplamSure += hesap != Infinity ? hesap : 0;
                    // _localNokta.guncelSure = hesap != Infinity ? _localNokta.guncelSure + hesap : _localNokta.guncelSure;

                }

                this.takimYolu.noktalar.push(_localNokta);
                /** */
                sonPoz += 1;
            }
            // birlesikNoktalar = birlesikNoktalar.concat(element.koordinatlar);
        }

        // console.log(birlesikNoktalar.length)
        for (let k = 0; k < birlesikNoktalar.length; k++) {
            const element = birlesikNoktalar[k];
            element.toplamSure = _toplamSure;
        }

    }

}